import BaseModel from 'src/model/base.model';

class ShipAddressModel extends BaseModel {
  public address: string = '';
  public address2: string = '';
  public addressId?: number = 0;
  public city: string = '';
  public country: string = '';
  public customerName: string = '';
  public state: string = '';
  public customerNumber: number = 0;
  public zipCode: string = '';
}

export default ShipAddressModel;
